/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setModal.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * モーダル
 */
const setModal = () => {
  let html = document.querySelector('html');
  let modalCloseBtn = document.querySelectorAll(".modal__close-btn");
  let modalCloseArea = document.querySelectorAll(".modal__close-area");
  let modalTriggers = document.querySelectorAll(".--js__modal-trigger");
  let modal__movie = document.querySelector("#about .movie");
  let aboutMovie = `<iframe id="-n2Xpf0kvCk" src="https://www.youtube.com/embed/-n2Xpf0kvCk?enablejsapi=1" title="YouTPINCH OPEN FUKUSHIMA" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;

  /**
   * 
   * 処理
   * 
   *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

  //オープン
  const openModal = (e) => {
    e.classList.add("--active");
    html.classList.add("--open-modal");
  }

  //クローズ
  const closeModal = () => {
    let currentModal = document.querySelectorAll(".modal.--active");
    let currentModal__inner = document.querySelectorAll(".modal.--active .modal__inner");
    currentModal[0].classList.remove("--active");
    currentModal__inner[0].scrollTop = 0;
    html.classList.remove("--open-modal");

    //iframe検知 - 動画削除
    if (currentModal[0].querySelector("iframe") !== null) {
      let currentIframe = currentModal[0].querySelector("iframe");
      currentIframe.remove();
    }
  }

  /**
   * 
   * 実行
   * 
   *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

  //オープン - 対象クリック
  for (let i = 0; i < modalTriggers.length; i++) {
    modalTriggers[i].addEventListener("click", (e) => {
      let currentTarget = e.currentTarget;
      let currentModal = document.getElementById(currentTarget.dataset.modal);
      if (currentModal !== null) {
        openModal(currentModal);
        if (currentTarget.dataset.modal === "about") modal__movie.innerHTML = aboutMovie;
      }
    });
  }

  //クローズ - 閉じるボタン
  for (let i = 0; i < modalCloseBtn.length; i++) {
    modalCloseBtn[i].addEventListener("click", () => closeModal());
  }

  //クローズ - 閉じるエリア
  for (let i = 0; i < modalCloseArea.length; i++) {
    modalCloseArea[i].addEventListener("click", () => closeModal());
  }

  //クローズ - ESCキー入力
  window.onkeydown = function (event) {
    html.classList.contains("--open-modal") ? event.keyCode == 27 && closeModal() : null;
  };
};

export {
  setModal
};